import { SegmentFilter } from 'src/gqlReactTypings.generated.d';
import { IconName } from 'web-common/src/shared/design-system/components/Icon';

export interface SegmentDisplayInfo {
  icon: IconName;
  hoverIcon: IconName;
  title: string;
  style?: React.CSSProperties;
}

export enum DefinedSubcuisines {
  NORTH_INDIAN = 'NORTH_INDIAN',
  SOUTH_INDIAN = 'SOUTH_INDIAN',
  BENGALI = 'BENGALI',
}

export const SegmentFilterDisplayInfo: { [filter in SegmentFilter | DefinedSubcuisines]?: SegmentDisplayInfo } = {
  [SegmentFilter.All]: { icon: 'allFood', hoverIcon: 'allFoodActive', title: 'All' },
  [SegmentFilter.Indian]: { icon: 'indian', hoverIcon: 'indianActive', title: 'Indian' },
  SOUTH_INDIAN: { icon: 'southIndian', hoverIcon: 'southIndianActive', title: 'South Indian' },
  NORTH_INDIAN: { icon: 'northIndian', hoverIcon: 'northIndianActive', title: 'North Indian' },
  BENGALI: { icon: 'genericCuisine', hoverIcon: 'genericCuisineActive', title: 'Bengali' },
  [SegmentFilter.Chinese]: { icon: 'chinese', hoverIcon: 'chineseActive', title: 'Chinese' },
  [SegmentFilter.MiddleEastern]: {
    icon: 'middleEastern',
    hoverIcon: 'middleEasternActive',
    title: 'Middle Eastern',
  },
  [SegmentFilter.Nepalese]: { icon: 'genericCuisine', hoverIcon: 'genericCuisineActive', title: 'Nepalese' },
  [SegmentFilter.Mexican]: { icon: 'mexico', hoverIcon: 'mexicoActive', title: 'Mexican' },
  [SegmentFilter.Korean]: { icon: 'korean', hoverIcon: 'koreanActive', title: 'Korean' },
  [SegmentFilter.African]: { icon: 'african', hoverIcon: 'africanActive', title: 'African' },
  [SegmentFilter.Southern]: { icon: 'southern', hoverIcon: 'southernActive', title: 'Southern' },
  [SegmentFilter.Pakistani]: {
    icon: 'pakistani',
    hoverIcon: 'pakistaniActive',
    title: 'Pakistani',
  },
  [SegmentFilter.Mediterranean]: {
    icon: 'mediterranean',
    hoverIcon: 'mediterraneanActive',
    title: 'Mediterranean',
  },
  [SegmentFilter.Caribbean]: { icon: 'caribbean', hoverIcon: 'caribbeanActive', title: 'Caribbean' },
  [SegmentFilter.LatinAmerican]: { icon: 'latinAmerica', hoverIcon: 'latinAmericaActive', title: 'Latin American' },
  [SegmentFilter.Italian]: { icon: 'italian', hoverIcon: 'italianActive', title: 'Italian' },
  [SegmentFilter.Japanese]: { icon: 'japanese', hoverIcon: 'japaneseActive', title: 'Japanese' },
  [SegmentFilter.SoutheastAsian]: {
    icon: 'southEastAsia',
    hoverIcon: 'southEastAsiaActive',
    title: 'Southeast Asian',
  },
  [SegmentFilter.American]: {
    icon: 'american',
    hoverIcon: 'americanActive',
    title: 'American',
  },
  [SegmentFilter.BakedGoods]: {
    icon: 'bakedGoods',
    hoverIcon: 'bakedGoodsActive',
    title: 'Baked Goods',
  },
  [SegmentFilter.More]: { icon: 'genericCuisine', hoverIcon: 'genericCuisineActive', title: 'More Cuisines' },
};
